import { initBrowserObservability } from "./src/instrumentation/browser";

initBrowserObservability();
